import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './shared/services/auth.service';
import { AuthGuard } from './shared/services/auth.guard';

import '@maersk-global/mds-components-core/mc-tab-bar';
import '@maersk-global/mds-components-core/mc-tab';
import '@maersk-global/mds-components-core/mc-pagination';
import '@maersk-global/mds-components-core/mc-tag';
import '@maersk-global/mds-components-core/mc-icon';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-button';
import "@maersk-global/mds-components-core/mc-checkbox";

import "@maersk-global/mds-components-core/mc-select";
import "@maersk-global/mds-components-core/mc-option";
import "@maersk-global/mds-components-core/mc-modal";

import "@maersk-global/mds-components-core/mc-loading-indicator";
// import "@maersk-global/mds-components-community/mc-c-left-hand-nav";

// import "@maersk-global/mds-components-core";

// import "@maersk-global/mds-components-community/mc-c-left-hand-nav";
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import "@maersk-global/mds-components-core/mc-typeahead";
import "@maersk-global/mds-components-core/mc-multi-select";
import "@maersk-global/mds-components-core/mc-file-upload";
import "@maersk-global/mds-components-core/mc-tag";
import { NgxSpinnerModule } from "ngx-spinner";
import '@maersk-global/mds-components-core-select-native';
import '@maersk-global/mds-components-core-input-date';

import "@maersk-global/mds-components-core/mc-toast";
import "@maersk-global/mds-components-core/mc-notification";
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { environment } from 'src/environments/environment';

import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { FailedComponent } from './failed/failed.component';
import '@maersk-global/mds-components-core/mc-popover';
import { InvalidFileComponent } from './invalid-file/invalid-file.component';


const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;



export function loggerCallback(logLevel: LogLevel, message: string) {
 // console.log(message);
}


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: window.location.origin + '/reliability/oil-analysis/',
      postLogoutRedirectUri: window.location.origin + '/reliability/oil-analysis/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // protectedResourceMap.set(environment.apiConfig.uri, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.apiBaseUrl, [environment.apiConfig.uri]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

// NOTE: this factory is currently NOT wired to MSAL_GUARD_CONFIG below - MSAL_GUARD_CONFIG
// uses MSALInterceptorConfigFactory instead, which is a different shape (protectedResourceMap,
// no authRequest). Wiring MsalGuard to use this factory instead would make the guard-triggered
// login request an explicit API scope up front, which is arguably more correct, but it IS a
// real change to the live login flow and needs to be tested against Azure AD before switching -
// don't rewire this without that validation. The scope bug below (string spread) is fixed since
// it costs nothing while this stays unused.
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.apiConfig.uri]
    },
    loginFailedRoute: '/login-failed'
  };
}



@NgModule({
  declarations: [
    AppComponent,
    FailedComponent,
    InvalidFileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayPanelModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule.forRoot(),
    MsalModule
  ],
  providers: [
    // { provide: APP_BASE_HREF, useValue: "/reliability/oil-analysis/" },
    AuthService, AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
